// extracted by mini-css-extract-plugin
export var pauseButton = "VideoPlayer-module--pauseButton--ecdcb";
export var pauseIcon = "VideoPlayer-module--pauseIcon--4fa66";
export var playButton = "VideoPlayer-module--playButton--36a24";
export var playIcon = "VideoPlayer-module--playIcon--05b96";
export var player = "VideoPlayer-module--player--35911";
export var playerWrapper = "VideoPlayer-module--playerWrapper--b531f";